import { Button, Tooltip } from "antd"
import { EditFilled, DeleteFilled, CopyFilled } from "@ant-design/icons"
import DataTable from "../../../components/DataTable/DataTable"
import SURVEYS_TABLE_COLUMNS from "../const/SURVEYS_TABLE_COLUMNS"
import { Survey } from "../../../../domain/entities/Survey"
import { useContainerInjection } from "../../../hooks/useContainerInjection"
import { SurveysViewModel } from "../SurveysViewModel"
import DataTableRowsSkeleton from "../../../styledComponents/LoadingSkeletons/DataTableRowsSkeleton"
import { Link } from "react-router-dom"
import { RoutePaths } from "../../../navigation/RoutePaths.enum"
import { toJS } from "mobx"
import { useTranslation } from "react-i18next"
import { SurveyOption } from "../../../survey/SurveyOption"

interface SurveysTableProps {
	data: Survey[]
}

const SurveysTable = ({ data }: SurveysTableProps) => {
	const viewModel = useContainerInjection<SurveysViewModel>("SurveysViewModel")
	const { t: tTooltips } = useTranslation("toolTips")
	const { t } = useTranslation("surveys")
	return (
		<DataTable
			loading={viewModel.isLoading}
			tableConfig={{
				sort: viewModel.tableConfig.sort,
				pageSize: viewModel.tableConfig.pageSize
			}}
			renderCustomLoadingComponent={() => <DataTableRowsSkeleton size="lg" />}
			onChange={data => {
				data.sorter &&
					viewModel.setTableConfig({ sort: { order: data.sorter.order, field: data.sorter.field } })
			}}
			onChangePage={(page, pageSize: number, lastPageFetched) => viewModel.setTableConfig({ pageSize })}
			columns={SURVEYS_TABLE_COLUMNS()}
			dataSource={data?.map((survey, idx) => {
				return {
					key: survey.id,
					id: survey.id,
					title: survey.title,
					description: survey.description,
					microsite: survey.microsites?.map(microsite => microsite.slug).join(", "),
					marketplace: survey.marketplaces?.join(", "),
					status: survey.status ? t("active") : t("inactive"),
					editButton: (
						<div className="ant-employed">
							<Link
								to={RoutePaths.SURVEYS_EDIT.replace(":id", survey.id!.toString())}
								state={{ survey: toJS(survey), option: SurveyOption.EDIT }}
							>
								<Tooltip title={tTooltips("edit")}>
									<EditFilled />
								</Tooltip>
							</Link>
						</div>
					),
					duplicateButton: (
						<div className="ant-employed">
							<Link
								to={RoutePaths.SURVEYS_NEW}
								state={{ survey: toJS(survey), option: SurveyOption.DUPLICATE }}
							>
								<Tooltip title={tTooltips("duplicate")}>
									<CopyFilled />
								</Tooltip>
							</Link>
						</div>
					)
				}
			})}
		/>
	)
}

export default SurveysTable
